import Embed from "./Embed";

export { Perspective } from "./types";
export default Embed;
